import { checkUser } from './AuthService';

export const getUserRole = async (user, selectedDomain) => {
    // 1. Validation de l'utilisateur
    if (!user || !user.primaryEmailAddress?.emailAddress) {
        // throw new Error("Utilisateur non authentifié");
    }

    try {
        const email = user.primaryEmailAddress.emailAddress;
        const userData = await checkUser(email);

        // 2. Gestion du rôle admin
        if (userData?.isAdmin) {
            if (selectedDomain) {
                sessionStorage.setItem("selectedDomain", JSON.stringify(selectedDomain));
                sessionStorage.setItem("userRole", "admin+manager");
                return "admin+manager";
            } else {
                sessionStorage.removeItem("selectedDomain");
                sessionStorage.setItem("userRole", "admin");
                return "admin";
            }
        }

        // 3. Gestion des rôles basés sur le domaine sélectionné
        if (selectedDomain) {
            // Vérifier si c'est un Validation Manager
            if (selectedDomain.isValidationManager) {
                sessionStorage.setItem("userRole", "validateur");
                return "validateur";
            }
            
            // Rôle normal du domaine
            if (selectedDomain.role) {
                sessionStorage.setItem("userRole", selectedDomain.role);
                return selectedDomain.role;
            }
        }

        // 4. Aucun rôle trouvé - on vérifie d'abord le cache
        const storedRole = sessionStorage.getItem("userRole");
        if (storedRole && storedRole !== "unknown") {
            // console.log(" Utilisation du rôle en cache:", storedRole);
            return storedRole;
        }

        throw new Error("Aucun rôle valide trouvé pour cet utilisateur");

    } catch (error) {
        // console.error("Erreur lors de la récupération du rôle :", error);
        
        // On vérifie le cache avant de propager l'erreur
        const storedRole = sessionStorage.getItem("userRole");
        if (storedRole && storedRole !== "unknown") {
            // console.log("Retour au rôle en cache après erreur:", storedRole);
            return storedRole;
        }
        
        throw error;
    }
};

export const getCurrentUserRole = () => {
  // Récupère le rôle depuis sessionStorage de manière synchrone
  const role = sessionStorage.getItem("userRole");
  
  // Retourne une valeur par défaut si vide
  return role || "";
};